// ===========================================================================
// The recovery code, shown exactly once.
//
// A step, not a notice. There is no email on a Lumi account, nor on a kept
// identity, and only a hash of this code is kept, so nobody -- including us
// -- can produce it again. If it is not written down here, a forgotten
// password later means asking an admin who has no way to prove who is
// asking. Shared by the sign-up form (ui/auth.js) and the account panel's
// "keep this identity" (ui/account-panel.js). ASCII only.
// ===========================================================================

import { t } from '../i18n.js';
import { el, toast } from '../dom.js';

/**
 * @param {string} code
 * @param {() => void} done  called once the person has acknowledged it
 * @param {{ what?: string }} [opts]  what the code is the way back into
 */
export function renderRecoveryCode(code, done, { what = 'your account' } = {}) {
  const codeEl = el('code', { class: 'recovery-code', text: code });
  const ack = el('input', { type: 'checkbox', id: 'rec-ack' });
  const go = el('button', { class: 'btn btn-primary', text: t('Continue'), disabled: true });
  ack.onchange = () => { go.disabled = !ack.checked; };
  go.onclick = () => { panel.remove(); done(); };

  const panel = el('div', { class: 'recovery-panel' }, [
    el('h3', { text: t('Write this down before you continue') }),
    el('p', { class: 'muted', text:
      `This is the only way back into ${what} if you forget your password. `
      + 'Lumi has no email address for you, so there is nothing to send a reset link to.' }),
    codeEl,
    el('div', { class: 'recovery-actions' }, [
      el('button', {
        class: 'btn btn-ghost btn-sm',
        text: t('Copy'),
        onClick: async () => {
          try {
            await navigator.clipboard.writeText(code);
            toast('Copied. Keep it somewhere you will still have it in a year.');
          } catch {
            // Clipboard access is refused often enough that failing silently
            // would look like a broken button.
            toast('Could not copy. Write it down instead.');
          }
        },
      }),
    ]),
    el('label', { class: 'recovery-ack' }, [ack, el('span', { text: t(' I have written it down or saved it') })]),
    go,
  ]);
  return panel;
}

export default { renderRecoveryCode };
